import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import { SHORTSLEG, BUILD, SWIMSHORTSLEG, CHEST_SIZE } from '@consts/index'
import HelpButton from '@components/ui/HelpButton'
import styles from './styles.module.scss'

const LegSubtitleWithModal = dynamic(() => import('./LegSubtitleWithModal'))
const BuildSubtitleWithModal = dynamic(() => import('./BuildSubtitleWithModal'))
const ChestSizeSubtitleWithModal = dynamic(
  () => import('./ChestSizeSubtitleWithModal')
)

type SubTitleProps = {
  type: string
  name?: string | React.ReactNode
  helperPressed: (args: string) => void
  showHelpButton: boolean
  helperOpen: boolean
  productType: string
  values: string[]
}

const SubTitle = ({
  type,
  productType,
  name,
  helperPressed,
  showHelpButton,
  helperOpen,
  values
}: SubTitleProps) => {
  const [openModal, setOpenModal] = useState(false)

  const toggleModal = () => {
    setOpenModal(currentState => !currentState)
  }

  if (
    type === SHORTSLEG.toLowerCase() ||
    type === SWIMSHORTSLEG.toLowerCase()
  ) {
    return (
      <LegSubtitleWithModal
        productType={productType}
        hasMoreThanOneLegSizeInStock={values.length > 1}
        modalOpen={openModal}
        toggleModal={toggleModal}
      />
    )
  }

  const isBuild = type === BUILD.toLowerCase()

  if (isBuild) {
    return (
      <BuildSubtitleWithModal modalOpen={openModal} toggleModal={toggleModal} />
    )
  }

  if (type === CHEST_SIZE.toLowerCase()) {
    return (
      <ChestSizeSubtitleWithModal
        modalOpen={openModal}
        toggleModal={toggleModal}
      />
    )
  }

  return (
    <div className={styles.subtitle__container}>
      <h2 className={styles.subtitle}>
        <span>{name}</span>
      </h2>
      {showHelpButton && (
        <HelpButton
          active={helperOpen}
          onClick={() => helperPressed(type)}
          classes="productForm__helper__button"
        />
      )}
    </div>
  )
}

export default SubTitle
